// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: 80px;
}

/* ── Decorative bowls ── */

.bowl-layer {
  position: absolute;
  inset: 0;
  height: 100%;
  pointer-events: none;
}

.bowl-layer-edge {
  z-index: 0;
}

.bowl-decoration {
  position: absolute;
  border-radius: 50%;
  object-fit: cover;
  pointer-events: auto;
  --bowl-scale: 1;
  --bowl-rotate: 0deg;
  transform: rotate(var(--bowl-rotate)) scale(var(--bowl-scale));
  transition: transform 0.25s ease;
}

.bowl-decoration:hover {
  transform: rotate(var(--bowl-rotate)) scale(calc(var(--bowl-scale) * 1.15));
}

/* ── Main content ── */

.about-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.about-photo-block {
  width: 100%;
  max-width: 700px;
}

.about-photo {
  width: 100%;
  height: auto;
  border-radius: 60px;
  object-fit: cover;
  display: block;
}

.about-headline {
  text-align: center;
}

.about-title {
  font-family: var(--font-display);
  font-size: clamp(48px, 10vw, 140px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
}

.about-subtitle {
  font-family: var(--font-display);
  font-size: clamp(36px, 7vw, 80px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
  margin-top: -8px;
}

.about-text {
  font-family: var(--font-body);
  font-size: clamp(16px, 1.6vw, 22px);
  color: var(--dark);
  line-height: 1.7;
  max-width: 700px;
  text-align: left;
}

@media (max-width: 900px) {
  .bowl-decoration {
    --bowl-scale: 0.7;
  }
}

@media (max-width: 600px) {
  .bowl-layer {
    display: none;
  }

  .about-content {
    padding: 20px 16px;
    gap: 24px;
  }

  .about-photo {
    border-radius: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,8DAA8D;EAC9D,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;AAC7E;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".about {\n  position: relative;\n  min-height: 100vh;\n  overflow: hidden;\n  padding-bottom: 80px;\n}\n\n/* ── Decorative bowls ── */\n\n.bowl-layer {\n  position: absolute;\n  inset: 0;\n  height: 100%;\n  pointer-events: none;\n}\n\n.bowl-layer-edge {\n  z-index: 0;\n}\n\n.bowl-decoration {\n  position: absolute;\n  border-radius: 50%;\n  object-fit: cover;\n  pointer-events: auto;\n  --bowl-scale: 1;\n  --bowl-rotate: 0deg;\n  transform: rotate(var(--bowl-rotate)) scale(var(--bowl-scale));\n  transition: transform 0.25s ease;\n}\n\n.bowl-decoration:hover {\n  transform: rotate(var(--bowl-rotate)) scale(calc(var(--bowl-scale) * 1.15));\n}\n\n/* ── Main content ── */\n\n.about-content {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n}\n\n.about-photo-block {\n  width: 100%;\n  max-width: 700px;\n}\n\n.about-photo {\n  width: 100%;\n  height: auto;\n  border-radius: 60px;\n  object-fit: cover;\n  display: block;\n}\n\n.about-headline {\n  text-align: center;\n}\n\n.about-title {\n  font-family: var(--font-display);\n  font-size: clamp(48px, 10vw, 140px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.about-subtitle {\n  font-family: var(--font-display);\n  font-size: clamp(36px, 7vw, 80px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n  margin-top: -8px;\n}\n\n.about-text {\n  font-family: var(--font-body);\n  font-size: clamp(16px, 1.6vw, 22px);\n  color: var(--dark);\n  line-height: 1.7;\n  max-width: 700px;\n  text-align: left;\n}\n\n@media (max-width: 900px) {\n  .bowl-decoration {\n    --bowl-scale: 0.7;\n  }\n}\n\n@media (max-width: 600px) {\n  .bowl-layer {\n    display: none;\n  }\n\n  .about-content {\n    padding: 20px 16px;\n    gap: 24px;\n  }\n\n  .about-photo {\n    border-radius: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
